import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/qrCodeClockIn";

const { actions, types } = createActions({
  requestFetchQrCode: ["id"],
  fetchQrCodeSucceeded: ["qrCode"],
  fetchQrCodeFailed: ["error"],

  requestValidateLocation: ["location"],
  validateLocationSucceeded: ["ip"],
  validateLocationFailed: ["error"],

  requestClockInLogin: ["data", "onSuccess", "onFailure"],
  clockInLoginSucceeded: ["user"],
  clockInLoginFailed: ["error"],

  requestClockInCheckToken: null,
  clockInCheckTokenFailed: null,

  requestClockInLogout: ["redirect"],
  clockInLogoutSucceeded: null,
  clockInLogoutFailed: ["error"],

  requestCheckIfClockedIn: null,
  checkIfClockedInSucceeded: ["shift"],
  checkIfClockedInFailed: ["error"],

  requestClockIn: ["onSuccess"],
  clockInSucceeded: ["shift"],
  clockInFailed: ["error"],

  requestClockOut: ["onSuccess", "profileImage", "signature"],
  clockOutSucceeded: null,
  clockOutFailed: ["error"],
});

const reducer = createReducer(initialState, {
  [types.REQUEST_FETCH_QR_CODE]: (state) => ({
    ...state,
    isFetchingQrCode: true,
    qrCode: null,
    fetchingQrCodeError: null,
  }),
  [types.FETCH_QR_CODE_SUCCEEDED]: (state, { payload: { qrCode } }) => ({
    ...state,
    isFetchingQrCode: false,
    qrCode,
  }),
  [types.FETCH_QR_CODE_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isFetchingQrCode: false,
    fetchingQrCodeError: error,
  }),

  [types.REQUEST_VALIDATE_LOCATION]: (state) => ({
    ...state,
    isValidatingLocation: true,
    hasValidatedLocation: false,
    isValidLocation: false,
    validatingLocationError: null,
  }),
  [types.VALIDATE_LOCATION_SUCCEEDED]: (state, { payload: { ip = null } }) => ({
    ...state,
    isValidatingLocation: false,
    hasValidatedLocation: true,
    isValidLocation: true,
    ip,
  }),
  [types.VALIDATE_LOCATION_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    ip: null,
    isValidatingLocation: false,
    hasValidatedLocation: true,
    validatingLocationError: error,
  }),

  [types.REQUEST_CLOCK_IN_LOGIN]: (state) => ({
    ...state,
    isLoggedIn: false,
    isLoggingIn: true,
    loggingInError: null,
    user: null,
  }),

  [types.REQUEST_CLOCK_IN_CHECK_TOKEN]: (state) => ({
    ...state,
    isLoggedIn: false,
    isCheckingToken: true,
    loggingInError: null,
    user: null,
  }),
  [types.CLOCK_IN_CHECK_TOKEN_FAILED]: (state) => ({
    ...state,
    isLoggingIn: false,
    isCheckingToken: false,
    loggingInError: null,
  }),

  [types.CLOCK_IN_LOGIN_SUCCEEDED]: (state, { payload: { user } }) => ({
    ...state,
    isLoggedIn: true,
    isLoggingIn: false,
    isCheckingToken: false,
    user,
  }),
  [types.CLOCK_IN_LOGIN_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isLoggingIn: false,
    loggingInError: error,
  }),

  [types.REQUEST_CLOCK_IN_LOGOUT]: (state) => ({
    ...state,
    isLoggingOut: true,
    loggingOutError: null,
  }),
  [types.CLOCK_IN_LOGOUT_SUCCEEDED]: (state) => ({
    ...state,
    isLoggingOut: false,
    isLoggedIn: false,
    user: null,
  }),
  [types.CLOCK_IN_LOGOUT_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isLoggingOut: false,
    loggingOutError: error,
  }),

  [types.REQUEST_CHECK_IF_CLOCKED_IN]: (state) => ({
    ...state,
    isCheckingIfClockedIn: true,
    checkingIfClockedInError: null,
    isClockedIn: false,
    shift: null,
  }),
  [types.CHECK_IF_CLOCKED_IN_SUCCEEDED]: (state, { payload: { shift } }) => ({
    ...state,
    isCheckingIfClockedIn: false,
    isClockedIn: true,
    shift,
  }),
  [types.CHECK_IF_CLOCKED_IN_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isCheckingIfClockedIn: false,
    checkingIfClockedInError: error,
  }),

  [types.REQUEST_CLOCK_IN]: (state) => ({
    ...state,
    isClockedIn: false,
    isClockingIn: true,
    clockingInError: null,
    shift: null,
  }),
  [types.CLOCK_IN_SUCCEEDED]: (state, { payload: { shift } }) => ({
    ...state,
    isClockedIn: true,
    isClockingIn: false,
    shift,
  }),
  [types.CLOCK_IN_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isClockingIn: false,
    clockingInError: error,
  }),

  [types.REQUEST_CLOCK_OUT]: (state) => ({
    ...state,
    isClockingOut: true,
    clockingOutError: null,
  }),
  [types.CLOCK_OUT_SUCCEEDED]: (state) => ({
    ...state,
    isClockedIn: false,
    isClockingOut: false,
    shift: null,
  }),
  [types.CLOCK_OUT_FAILED]: (state, { payload: { error } }) => ({
    ...state,
    isClockingOut: false,
    clockingOutError: error,
  }),
});

export { reducer as default, types, actions };
